/*
 * The statement read and the shared Ops column mappings, kept beside the page (not in ../api.js) so
 * this branch stays additive; same group, JWT and payment grant as the Overview routes.
 */
import { get_api, post_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import { envelope_data } from '../format';
import { fetch_drilldown } from '../api';
import { drilldown_params } from '../overview/params';
import { LINE_CATEGORIES } from './logic';

const GROUP = '/v2/cms_user/teacher_payments';

export const statement_url = (month) =>
  get_api_url(`${GROUP}/overview/statement?month=${encodeURIComponent(month)}`);
export const mappings_url = (path = '') => get_api_url(`${GROUP}/statement/mappings${path}`);

export const fetch_statement = (month) => get_api(statement_url(month), true).then(envelope_data);

export const fetch_mappings = () => get_api(mappings_url(), true).then(envelope_data);
// body { sheet_header, action, column_key? } -> { mapping }
export const post_mapping_set = (body) =>
  post_api(mappings_url('/set'), body, true).then(envelope_data);
// body { sheet_header } -> { removed }
export const post_mapping_remove = (body) =>
  post_api(mappings_url('/remove'), body, true).then(envelope_data);

// One teacher's month of drill-down lines, every category (the endpoint takes one at a time).
export const fetch_teacher_lines = (teacher_uuid, month) =>
  Promise.all(
    LINE_CATEGORIES.map((category) =>
      fetch_drilldown(drilldown_params({ teacher_uuid, pay_month: month, category, kind: 'all' }))
    )
  );

export { fetch_months } from '../api';
